// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"903d9734","536":"aab87999","643":"2014eded"}[chunkId] + ".chunk.js";
};